import PhoneInput, { PhoneValue } from "@/components/PhoneInput";
import { isRTLLanguage } from "@/utils/helpers";
import { useField } from "formik";
import { useId } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  name: string;
  label: string;
  onChange?: (value: PhoneValue) => void;
}

export default function PhoneInputField(props: Readonly<Props>) {
  const [field, meta] = useField<PhoneValue>({ name: props.name });
  const id = useId();

  const { i18n } = useTranslation();
  return (
    <div className="flex flex-col gap-2">
      <label
        dir={isRTLLanguage(i18n.language) ? "rtl" : "ltr"}
        htmlFor={id}
        className="block text-start text-xs font-bold text-foreground md:text-sm"
      >
        {props.label}
      </label>
      <PhoneInput
        inputProps={{
          id,
          name: props.name,
          "data-invalid": meta.error && meta.touched ? "true" : undefined,
          onBlur: field.onBlur,
        }}
        initialValue={field.value.number}
        onChange={props.onChange}
      />
      {meta.error && meta.touched && (
        <div className="text-start text-sm text-[#F04438] empty:hidden">
          {/* @ts-expect-error */}
          {meta.error.number ?? meta.error.isValid}
        </div>
      )}
    </div>
  );
}
